import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import type { HeadingBlockInterface } from '~/types/AppData/PageBuilder/HeadingBlockInterface';
import SectionHeader from '~/components/Layout/Body/Page/SectionHeader';

const headingClasses = cva('', {
  variants: {
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
  },
});

export default component$<HeadingBlockInterface['props']>(
  ({ text, level, align, style, index }) => {
    if (style === 'section') {
      return (
        <SectionHeader
          title={text}
          showDivider={true}
          level={level}
          index={index}
        />
      );
    }

    const Component = level;
    return <Component class={headingClasses({ align })}>{text}</Component>;
  }
);
